import React from 'react';
import { App } from 'antd';
import { ENotificationType, Icon, EIconNames } from '@idaho-aeyc/ui-kit';
import { useTranslation } from '@packages/utils';

const useShowToastNotification = () => {
  const { notification } = App.useApp();
  const { t } = useTranslation({
    keyPrefix: 'descriptions.messages',
  });
  const showToastNotification = ({
    message,
    type,
  }: {
    message?: string;
    type: ENotificationType;
  }) => {
    let toastMessage = message;
    if (type === ENotificationType.ERROR && !message) {
      toastMessage = t('error.SOMETHING_WENT_WRONG');
    }
    notification.open({
      message: toastMessage,
      type,
      className: 'custom-notification',
      closeIcon: (
        <Icon
          size={24}
          icon={EIconNames.CLOSE}
          alt="close icon of notification"
          data-testid="notification-close-icon"
          color="#fff"
        />
      ),
      placement: 'bottom',
    });
  };
  return { showToastNotification };
};

export { useShowToastNotification, ENotificationType };
